import React, { useState, useEffect } from "react";

const MandatoryFollowsTab = ({ initialAccounts, onDataChange }) => {
  const [defaultFollowAccounts, setDefaultFollowAccounts] = useState(
    initialAccounts || []
  );
  const [newFollowAccount, setNewFollowAccount] = useState("");

  useEffect(() => {
    if (typeof onDataChange === "function") {
      onDataChange(defaultFollowAccounts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFollowAccounts]);

  const addFollowAccount = () => {
    const clean = newFollowAccount.trim().replace("@", "");
    if (!clean) return;
    if (defaultFollowAccounts.includes(clean)) {
      setNewFollowAccount("");
      return;
    }
    if (defaultFollowAccounts.length >= 5) {
      alert("Maximum 5 mandatory follow accounts allowed.");
      return;
    }
    setDefaultFollowAccounts([...defaultFollowAccounts, clean]);
    setNewFollowAccount("");
  };

  const removeFollowAccount = (username) => {
    setDefaultFollowAccounts(defaultFollowAccounts.filter((u) => u !== username));
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div className="mb-8 pb-4 border-b border-gray-50">
        <h2 className="text-xl font-bold text-gray-900">Mandatory Follow Accounts</h2>
        <p className="text-sm text-gray-500 mt-1">
          These accounts will be shown at the top of the sponsor list for every participant.
        </p>
      </div>

      <div className="bg-pink-50 border border-pink-100 rounded-lg p-4 mb-8 flex gap-3">
        <div className="text-pink-500 mt-0.5">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <p className="text-sm text-pink-800 leading-relaxed">
          Participants <strong>must follow</strong> these accounts during the entry process. 
          Use this for internal test accounts or primary event sponsors.
        </p>
      </div>

      <div className="flex gap-2 mb-6">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-medium">@</span>
          <input
            type="text"
            value={newFollowAccount}
            onChange={(e) => setNewFollowAccount(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && addFollowAccount()}
            placeholder="username"
            className="w-full pl-8 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 outline-none transition-all"
          />
        </div>
        <button
          type="button"
          onClick={addFollowAccount}
          className="px-6 py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 font-bold shadow-sm transition-all active:scale-95"
        >
          Add
        </button>
      </div>

      <div className="flex flex-wrap gap-3">
        {defaultFollowAccounts.map((username) => (
          <div
            key={username}
            className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-pink-200 text-pink-700 rounded-full text-sm font-semibold shadow-sm hover:border-pink-300 transition-colors"
          >
            <span>@{username}</span>
            <button
              type="button"
              onClick={() => removeFollowAccount(username)}
              className="p-0.5 hover:bg-pink-100 rounded-full transition-colors text-pink-400 hover:text-pink-600"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ))}
        {defaultFollowAccounts.length === 0 && (
          <div className="w-full py-12 text-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
            <p className="text-gray-400 italic">No mandatory accounts added yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MandatoryFollowsTab;
